import { render } from "./StorePicManager.vue?vue&type=template&id=487772d6&scoped=true"
import script from "./StorePicManager.vue?vue&type=script&lang=js"
export * from "./StorePicManager.vue?vue&type=script&lang=js"

import "./StorePicManager.vue?vue&type=style&index=0&id=487772d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487772d6"]])

export default __exports__